export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Зберегти"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Якщо ви це бачите, форму не було отримано (але ви не повинні це бачити)"])}
}